import { css } from 'styled-components';

export const slotInputStyle = css<{ $fullWidth?: boolean }>`
  width: 100%;
  max-width: ${p => (p.$fullWidth ? 'none' : '223px')};
`;
